module.exports = __webpack_public_path__ + "img/ki.cdeef8df.svg";